module.exports = new __parcel__URL__("step_one_vector_light.5040164b.png").toString();